export const presets = [
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v2/assets/XVLduoEAsxwBzdoteDgxS~200/webPreview?signature=a46eca415d9edd416fb23e2f94d2465fa631709f',
        title: 'Music Poster',
        type: 'image',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v2/assets/aqePF8sbdVZ1Jzhqonk5z~200/webPreview?signature=f430413822ba743f1bf23141a26deb919ff48b04',
        title: 'Monochrome Business Card',
        type: 'image',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v2/assets/eCe_T_lEckX1H8kcYprwm~200/webPreview?signature=a03a7fa353fffe1a7b473567e2c36de6e48f9e4e',
        title: 'Business Card',
        type: 'image',
    },
    {
        fileUrl: 'https://d2522lbqemijwv.cloudfront.net/raster-to-cimdoc-examples/4.png',
        title: 'Business Card 2',
        type: 'image',
    },
    {
        fileUrl: 'https://d2522lbqemijwv.cloudfront.net/raster-to-cimdoc-examples/10.png',
        title: 'Business Card 3',
        type: 'image',
    },
    {
        fileUrl: 'https://d2522lbqemijwv.cloudfront.net/raster-to-cimdoc-examples/11.png',
        title: 'Business Card 4',
        type: 'image',
    },
    {
        fileUrl: 'https://d2522lbqemijwv.cloudfront.net/raster-to-cimdoc-examples/12.png',
        title: 'Business Card 5',
        type: 'image',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v3/assets/Ez_xGfoRoQRVNnY-Mfdbs~300/versions/1?signature=9eaf82bf5d226bcf91c33bcb340c49158e091bc0',
        title: 'Digital Marketing Agency Flyer PDF',
        type: 'pdf',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v3/assets/EcMYo1nHBaTbjqCqbWvHy~300/versions/1?signature=143b5b8e8ca518a220bb8b469b507f6b2fc9f757',
        title: 'Resume PDF',
        type: 'pdf',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v3/assets/uNaQ_PHZgYCDo1EDAuUAt~300/versions/1?signature=a5b644b40c2ebd4d684544c4cef9b4ee8b8bd86f',
        title: 'Visiting Card PDF',
        type: 'pdf',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v3/assets/iBtelfIDlkvmc5gkRX2Fq~300/versions/1?signature=21558fd1242ecababbf292f44825f83dcb986627',
        title: 'BusinessCard PDF', // Note: This is a PDF where Prepress returns only fullbleed image
        type: 'pdf',
    },
    {
        fileUrl:
            'https://api.sherbert.cimpress.io/v3/assets/0ET6UB6vB5AUzfw6OOTqc~300/versions/1?signature=5d04b5c2769d3d02d9347ee0f47af4338978e365',
        title: 'Hello June Card PDF',
        type: 'pdf',
    },
] as const;
